import { render, staticRenderFns } from "./KidsProductShippingPrices.vue?vue&type=template&id=06d89621&"
import script from "./KidsProductShippingPrices.vue?vue&type=script&lang=js&"
export * from "./KidsProductShippingPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports